<script setup lang="ts">
const dynamicPages = {
  404: defineAsyncComponent(() => import('~layers/pages/~404.vue')),
  PLP: defineAsyncComponent(() => import('~layers/pages/~plp.vue')),
  PDP: defineAsyncComponent(() => import('~layers/pages/~pdp.vue')),
  Page: defineAsyncComponent(() => import('~layers/pages/~cms.vue')),
  BlogDetail: defineAsyncComponent(() => import('~layers/pages/~blog-detail.vue')),
  BlogOverview: defineAsyncComponent(() => import('~layers/pages/~blog-overview.vue')),
  // CustomerService: defineAsyncComponent(() => import('~layers/pages/~customer-service-overview.vue')),
  CustomerServiceOverview: defineAsyncComponent(() => import('~layers/pages/~customer-service-overview.vue')),
  CustomerServiceDetail: defineAsyncComponent(() => import('~layers/pages/~customer-service-detail.vue')),
  StoreDetail: defineAsyncComponent(() => import('~layers/pages/~store-detail.vue')),
  StoreOverview: defineAsyncComponent(() => import('~layers/pages/~store-overview.vue')),
}

const route = useRoute()
const { fetchRoute } = useCustomRouter()
const { fetchRedirect } = useCustomRouterRedirect()

const esUrlPath = computed(() => route.path.replace(/^\/+|\/+$/g, ''))

const metaData = await fetchRoute(route.path)
provide('meta', ref(metaData))

// Resolve page/component to render
const pageComponent = computed(() => {
  return (metaData?.page_type && dynamicPages?.[metaData.page_type]) || dynamicPages?.['404']
})

const redirect = ref()

// No meta data, or unknown component, check for redirect
if (!metaData) {
  redirect.value = await fetchRedirect(esUrlPath.value)
  // console.log({ redirect })
  if (redirect.value?.relative_url) {
    // console.log(`redirect to: ${redirect?.relative_url}`)
    await navigateTo(redirect.value?.relative_url, {
      redirectCode: redirect.value?.redirectCode || 301,
      external: true,
    })
  }
  else {
    const event = useRequestEvent()

    if (event) {
      setResponseStatus(event, 404, 'Page Not Found')
    }
  }
}
</script>

<template>
  <component
    :is="pageComponent"
    :meta="metaData"
  />
</template>
